import React from 'react';
import { BubbleNavigation } from '../BubbleUI';
import { resolveReservePath } from '@go-client/routes';
import { useActiveProperty } from '@go-client/context/ActivePropertyContext';

export default function ReserveNavigation(props: { active: 'reserve' | 'analyze' | 'settings' }) {
  const { activeProperty } = useActiveProperty();

  return (
    <BubbleNavigation
      items={[
        {
          name: 'Reserve',
          to: resolveReservePath(activeProperty._id, 'experiences'),
          active: props.active === 'reserve',
          variant: 'turquoise',
        },
        {
          name: 'Analyze',
          to: resolveReservePath(activeProperty._id, 'analyze'),
          active: props.active === 'analyze',
          variant: 'turquoise',
        },
        {
          name: 'Settings',
          to: resolveReservePath(activeProperty._id, 'profile'),
          active: props.active === 'settings',
          variant: 'turquoise',
        },
      ]}
    />
  );
}
